import React from "react";
import { formatPrice } from "../utils/helpers";
export default (props) => {
    const addonItems = props.addons.map((a, index) => (React.createElement("div", { key: index },
        a.title,
        " - ",
        formatPrice(a.price),
        a.unit)));
    const hasAddons = addonItems.length > 0;
    const hasPrice = props.price !== null;
    return (React.createElement("div", { className: "product-card-content" },
        React.createElement("div", { "data-ecom-columnrow": "" },
            React.createElement("div", { className: "column" },
                React.createElement("div", { className: "font-medium" }, props.title)),
            hasPrice && (React.createElement("div", { className: "column" },
                formatPrice(props.price),
                props.unit))),
        React.createElement("div", { className: "font-size-small" }, props.description),
        hasAddons && (React.createElement("div", { className: "font-size-small m-t-mini" }, addonItems))));
};
